import { L, vocabulary } from '../define.js';
/** D577 slice a — generated from the domain code lists; every vocabulary is typed against its source. */
export const MISC_VIEWS_VOCABULARIES = [
    vocabulary('risk_area.status', '@vello/risk-areas RISK_AREA_STATUSES; @vello/api-client IncentiveZoneStatusView; RiskAreaStatusView', {
        PROPOSED: L('Aguardando decisão', 'Awaiting decision', 'A la espera de decisión', 'In attesa di decisione'),
        APPROVED: L('Aprovada', 'Approved', 'Aprobada', 'Approvata'),
        REJECTED: L('Rejeitada', 'Rejected', 'Rechazada', 'Rifiutata'),
    }),
    vocabulary('webhook.secret_source', '@vello/api-client WebhookSecretSource', {
        vault: L('No cofre de segredos', 'In the secrets vault', 'En la bóveda de secretos', 'Nel vault dei segreti'),
        env: L('No ambiente do servidor', 'In the server environment', 'En el entorno del servidor', 'Nell’ambiente del server'),
        none: L('Nenhum segredo', 'No secret', 'Sin secreto', 'Nessun segreto'),
    }),
    vocabulary('driver.location_lifecycle_state', '@vello/api-client LocationLifecycleState', {
        offline: L('Offline', 'Offline', 'Fuera de línea', 'Offline'),
        available: L('Disponível', 'Available', 'Disponible', 'Disponibile'),
        offered: L('Recebendo oferta', 'Receiving an offer', 'Recibiendo una oferta', 'Offerta in arrivo'),
        pickup: L('A caminho do embarque', 'Heading to pickup', 'Yendo a la recogida', 'Verso il ritiro'),
        waiting: L('Aguardando o passageiro', 'Waiting for the rider', 'Esperando al pasajero', 'In attesa del passeggero'),
        trip: L('Em corrida', 'On a trip', 'En viaje', 'In corsa'),
        paused: L('Em pausa', 'Paused', 'En pausa', 'In pausa'),
    }),
    vocabulary('notifications.publish_template_result', '@vello/api-client PublishTemplateResult', {
        PUBLISHED: L('Publicado', 'Published', 'Publicado', 'Pubblicato'),
        UNCHANGED: L('Sem mudanças', 'Unchanged', 'Sin cambios', 'Nessuna modifica'),
    }),
    vocabulary('omnichannel.ingest_outcome', '@vello/api-client OmnichannelIngestOutcome', {
        accepted: L('Mensagem recebida', 'Message received', 'Mensaje recibido', 'Messaggio ricevuto'),
        duplicate: L('Mensagem repetida, ignorada', 'Duplicate message, ignored', 'Mensaje repetido, ignorado', 'Messaggio duplicato, ignorato'),
        out_of_order: L('Mensagem fora de ordem', 'Message out of order', 'Mensaje fuera de orden', 'Messaggio fuori ordine'),
    }),
];
//# sourceMappingURL=misc-views.js.map